import { ReactComponent as MenuSVG } from '@/asset/svg/menu.svg'
import useStatePopup from '@/hook/useStatePopup'
import useThemeBasis from '@/hook/useThemeBasis'
import { PopupSelector, PopUpStore } from '@/store/PopupStore'
import React from 'react'

const MenuBtn: React.FC<PropType> = () => {
  const menuPopupVisible = useStatePopup(PopupSelector.menuPopupVisible)
  const { lightHeader, lightAndroidHeader } = useThemeBasis()

  const handleClick = () => {
    PopUpStore.setMenuPopupVisible(!menuPopupVisible)
  }

  return (
    <button className="flex h-full w-full items-center justify-center" onClick={handleClick}>
      {/* <MenuSVG className={`w-7 ${menuPopupVisible ? 'rotate-180' : ''}`} /> */}
      <MenuSVG className={`w-6 text-primary-text`} />
    </button>
  )
}

interface PropType {}

export default MenuBtn
